export const orderTextInputFields = [
  {
    name        : 'number',
    label       : 'Number',
    type        : 'text',
    placeholder : 'Search by Order Number'
  },
  {
    name        : 'payment_method_name',
    label       : 'Payment Method',
    type        : 'text',
    placeholder : 'Search by Payment Method'
  },
  {
    name        : 'item_sku',
    label       : 'Items SKU',
    type        : 'text',
    placeholder : 'Search by Items SKU'
  },
  {
    name        : 'discount_code',
    label       : 'Voucher Code',
    type        : 'text',
    placeholder : 'Search by Voucher Code'
  },
  {
    name        : 'affiliate_name',
    label       : 'Affiliate',
    type        : 'text',
    placeholder : 'Search by Affiliate Name'
  }
]

export const customerTextInputFields = [
  {
    name        : 'customer_name',
    label       : 'Name',
    type        : 'text',
    placeholder : 'Search by Customer Name'
  },
  {
    name        : 'email',
    label       : 'Email',
    type        : 'text',
    placeholder : 'Search by Customer Email'
  },
  {
    name        : 'customer_phone',
    label       : 'Phone',
    type        : 'text',
    placeholder : 'Search by Customer Phone Number'
  }
]